import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['details', 'type', 'userForm', 'mcInput']

  selectType() {
    if (this.typeTarget.value == "Site::Audience::Local") {
      this.detailsTarget.classList.add("hidden")
      this.mcInputTargets.forEach( (elem) => { elem.disabled = true } );
    } else {
      this.detailsTarget.classList.remove("hidden")
      this.mcInputTargets.forEach( (elem) => { elem.disabled = false } );
    }
  }

  // requestSubmit() (not submit()) dispatches a real submit event, which
  // Turbo intercepts. With a turbo_stream responder on the server, the
  // checkbox toggle replaces just its turbo_frame instead of triggering
  // a full page reload. submit() bypasses Turbo entirely.
  updateUser(event) {
    this.userFormTarget.requestSubmit();
  }
}
